// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1FOEp","detailsBorder":"styles_detailsBorder__1vtEL"};